import {
  useWSModal,
  WSActions,
  WSAlert,
  WSButton,
  WSElement,
  WSFlexBox,
  WSPanel
} from "@wingspanhq/fe-component-library";
import {
  IPayeeEngagementResponse,
  IPayeeResponse
} from "@wingspanhq/payments/dist/interfaces";
import { FieldView } from "../../../shared/components/FieldView/FieldView";
import React from "react";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";
import { useHistory } from "react-router-dom";

export interface ArchivalNotAllowedModalProps {
  payee: IPayeeResponse;
  engagement: IPayeeEngagementResponse;
  onClose: () => void;
}

export const ArchivalNotAllowedModal: React.FC<
  ArchivalNotAllowedModalProps
> = ({ payee, engagement, onClose }) => {
  const history = useHistory();

  const payeeNames = wsName({
    user: payee.user!,
    member: payee.member
  });

  return (
    <>
      <WSPanel>
        <WSFlexBox gap="XL">
          <FieldView
            label="Assignment name"
            value={engagement.engagementName}
          />
          <FieldView
            label="Contractor name"
            value={payeeNames.getResolvedName()}
          />
        </WSFlexBox>
      </WSPanel>

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Assignment cannot be archived when:"
      >
        Outstanding invoices exist - they must be canceled or paid out first
        before the assignment can be archived.
        <WSElement>
          <WSButton.Link
            rightIcon="chevron-right"
            onClick={() => {
              history.push(
                `/member/invoices/payables/all?payeeId=${payee.payeeId}`
              );
            }}
          >
            View invoices
          </WSButton.Link>
        </WSElement>
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useArchivalNotAllowedModal = () => {
  return useWSModal(ArchivalNotAllowedModal, {
    title: "Assignment cannot be archived",
    size: "M"
  });
};
